import { FormGroup } from '@angular/forms';

export function markAllControlsAsUntouched(form: FormGroup) {
  Object.values(form.controls).forEach(control => {
    control.markAsUntouched();
    control.markAsPristine();
    control.setErrors(null);
  });
}
